import { Chip, ChipProps } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface VisitRequestButtonProps {
  status: string;
}

const VisitRequestButton = ({ status }: VisitRequestButtonProps) => {
  // 다국어
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'ko');
  const { t, i18n } = useTranslation(); // useTranslation 훅 사용

  const VISIT_STATUS = {
    REQUESTED: { label: t('visit_request_list.status_list.request'), color: 'inherit', disabled: false },
    APPROVED: { label: t('visit_request_list.status_list.approve'), color: 'primary', disabled: false },
    REQUEST_COMPLETED: { label: t('visit_request_list.status_list.request_complete'), color: 'success', disabled: false },
    REJECTED: { label: t('visit_request_list.status_list.reject'), color: 'error', disabled: false },
    CANCELED: { label: t('visit_request_list.status_list.cancel'), color: 'inherit', disabled: false }
  };

  // status가 VISIT_STATUS의 키인지 확인
  const visitStatus = VISIT_STATUS[status as keyof typeof VISIT_STATUS];

  // 만약 status가 유효하지 않다면 기본값 설정
  const { label = '상태 없음', color = 'inherit', disabled = false } = visitStatus || {};

  useEffect(() => {
    const handleStorageChange = () => {
      setLanguage(localStorage.getItem('language') || 'ko');
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <Chip
      variant="outlined"
      color={color as ChipProps['color']}
      size="small"
      label={label}
      disabled={disabled}
      sx={{ paddingX: '8px', fontSize: '12px', borderRadius: '4px', userSelect: 'none' }}
    />
  );
};

export default VisitRequestButton;
